export enum DepositMethodsQueryKeys {
  Primary = 'deposit-methods/',
  ById = 'deposit-methods/:id',
}
